import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

class DropDownFilter extends PureComponent {
  handleSelectFilter = (e) => {
    const value = e.target.value === this.props.defaultValue ? null : e.target.value
    const name = this.props.filterName ? this.props.filterName : 'status'
    this.props.updateFilter({ [name]: value })
  }

  render() {
    const { props } = this
    const { filter, values, defaultValue } = props
    const selectedFilter = filter ? filter : defaultValue
    return (
      <div className='form-group'>
        <select
          value={selectedFilter}
          name='status'
          id='status'
          className='form-control'
          onChange={this.handleSelectFilter}
        >
          <option key={defaultValue} defaultValue={defaultValue}>
            {defaultValue}
          </option>
          {values.map((status) => (
            <option key={status} value={status}>
              {status.toUpperCase()}
            </option>
          ))}
        </select>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DropDownFilter))
